import { render, staticRenderFns } from "./aboutList.vue?vue&type=template&id=415d119c&scoped=true"
import script from "./aboutList.vue?vue&type=script&lang=js"
export * from "./aboutList.vue?vue&type=script&lang=js"
import style0 from "./aboutList.vue?vue&type=style&index=0&id=415d119c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "415d119c",
  null
  
)

export default component.exports